import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Home as HomeIcon,
  Wallet as WalletIcon,
  PeopleAlt as PeopleAltIcon,
  MoreVert as MoreVertIcon,
} from "@mui/icons-material";

import "./navbar.scss";
import { AuthContext } from "../../context/AuthContext";
import Logo from "../../assets/images/logo2.png";
import Loading from "../Loading/Loading";
import { authHeader } from "../../utils/authHeader";
import { API_BASE_URL, urlDeArchivo } from "../../config";

const Navbar = ({ setView, toggleSidebar }) => {
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState(null);
  const [userLoading, setUserLoading] = useState(false);

  useEffect(() => {
    const fetchUserInfo = async () => {
      setUserLoading(true);
      try {
        const res = await fetch(`${API_BASE_URL}/api/users/${currentUser.id}`, {
          headers: { ...authHeader() },
        });
        if (!res.ok) throw new Error("Error al obtener datos del usuario");
        const data = await res.json();
        setUserInfo(data);
      } catch (err) {
        console.error("Error al cargar información del usuario:", err);
      } finally {
        setUserLoading(false);
      }
    };

    if (currentUser?.id) {
      fetchUserInfo();
    }
  }, [currentUser]);

  const userToDisplay = userInfo || currentUser;

  const handleGoHome = () => {
    if (typeof setView === "function") {
      setView("feed");
      return;
    }
    navigate("/");
  };

  const handleGoSecondary = () => {
    if (typeof setView === "function") {
      setView("rewards");
      return;
    }
    if (currentUser?.rol === "admin") {
      navigate("/");
      return;
    }
    navigate("/");
  };

  return (
    <div className="navbarContainer">
      <div className="navbarLeft">
        <Link to="/" style={{ textDecoration: "none" }}>
          <img src={Logo} alt="Logo" className="navbarImg" />
        </Link>
      </div>

      <div className="navbarCenter">
        <div className="navbarIcons">
          <div className="navbarIconItem" onClick={handleGoHome}>
            <HomeIcon />
          </div>
          <div className="navbarIconItem" onClick={handleGoSecondary}>
            {userLoading ? <Loading small /> : <WalletIcon />}
          </div>
        </div>
      </div>

      <div className="navbarRight">
        {/* Acceso al panel de administración. Antes solo existía dentro de
            la tarjeta de información del perfil, así que había que entrar al
            perfil para encontrarlo. Aquí está siempre a la vista, en todas
            las pantallas, y solo para quien tiene rol admin. */}
        {currentUser?.rol === "admin" && (
          <Link to="/admin" className="navbarAdminBtn" title="Panel de administración">
            <PeopleAltIcon fontSize="small" />
            <span>Panel admin</span>
          </Link>
        )}
        {userToDisplay && (
          <Link to={`/profile/${userToDisplay.username}`}>
            <img
              src={urlDeArchivo(userToDisplay.profilePicture) || "/assets/profileCover/DefaultProfile.jpg"}
              alt={userToDisplay.name || "user"}
              className="navbarImg"
            />
          </Link>
        )}
      </div>

      {/* Botón de tres puntos para móviles */}
      <div className="mobileMenuIcon">
        <MoreVertIcon onClick={toggleSidebar} />
      </div>
    </div>
  );
};

export default Navbar;
